export const INVOICE_PREFIX = 'budgetInvoice:'
export const INVOICE_PATTERN = '.pdf,.jpg,.jpeg,.png'
export const ITEM_ID_PATTERN = /^[a-zA-Z0-9_-]{8,80}$/

export type InvoiceReference = {
  storage: 'loanpro'
  docId: string
  customerId: number | string
  budgetItemId: string
  name: string
  originalName: string
  loanproFileName: string
  size: number
  type: string
  url: string
}

export function invoiceItemId(dir?: string): string | undefined {
  if (!dir?.startsWith(INVOICE_PREFIX)) return undefined
  const id = dir.slice(INVOICE_PREFIX.length)
  if (!ITEM_ID_PATTERN.test(id)) throw new Error('Could not identify this budget item. Please reopen the form.')
  return id
}

export function validateInvoiceFile(file: Pick<File, 'name' | 'size'>): void {
  if (!/\.(pdf|jpe?g|png)$/i.test(file.name)) throw new Error('Upload an invoice as a PDF, JPG or PNG.')
  if (file.size === 0) throw new Error('The invoice file is empty.')
  if (file.size > 10 * 1024 * 1024) throw new Error('The invoice must be 10 MB or smaller.')
}

export function validateBudgetInvoices(rows: Record<string, unknown>[]): void {
  const seen = new Set<string>()
  rows.forEach((row, index) => {
    const itemId = row.budgetItemId
    if (typeof itemId !== 'string' || !ITEM_ID_PATTERN.test(itemId) || seen.has(itemId)) {
      throw new Error(`Budget item ${index + 1} has an invalid identifier. Please reopen the form.`)
    }
    seen.add(itemId)
    const invoices = row.invoice
    const invoice = Array.isArray(invoices) && invoices.length === 1 ? invoices[0] as Partial<InvoiceReference> : null
    if (!invoice || invoice.storage !== 'loanpro' || !invoice.docId || invoice.budgetItemId !== itemId) {
      throw new Error(`Upload an invoice for budget item ${index + 1} before submitting.`)
    }
  })
}
